import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, className = "", y = 44 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const ClipImage = ({ src, alt, className = "", imgClassName = "", imgStyle }) => (
  <motion.div
    className={`overflow-hidden ${className}`}
    initial={{ clipPath: "inset(100% 0 0 0)" }}
    whileInView={{ clipPath: "inset(0% 0 0 0)" }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 1.1, ease: EASE }}
  >
    <motion.img
      src={src}
      alt={alt}
      style={imgStyle}
      className={`h-full w-full object-cover ${imgClassName}`}
      initial={{ scale: 1.25 }}
      whileInView={{ scale: 1 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 1.5, ease: EASE }}
    />
  </motion.div>
);

export const SectionTag = ({ index, label }) => (
  <p className="font-mono text-xs uppercase tracking-[0.25em] text-pale/70">
    <span className="text-forest">{index}</span>
    <span className="mx-3 inline-block h-px w-8 translate-y-[-3px] bg-white/20" />
    {label}
  </p>
);
